function validateRequest(form) {
  if (
    typeof form.email !== "string" ||
    form.email.length > 254 ||
    !/^[^\s@<>]+@[^\s@<>]+\.[^\s@<>]+$/.test(form.email)
  )
    return "Enter a valid email address.";
  if (!form.acknowledged)
    return "Please acknowledge the prototype and non-binding request terms.";
  if (
    typeof form.name !== "string" ||
    form.name.length > 100 ||
    /[\r\n\x00]/.test(form.name)
  )
    return "Use a name of up to 100 characters on one line.";
  if (
    typeof form.message !== "string" ||
    form.message.length > 2000 ||
    /\x00/.test(form.message)
  )
    return "Keep your message to 2,000 characters.";
  if (!["", "1", "2–10", "11–50", "51+"].includes(form.websites))
    return "Choose a valid number of websites.";
  return "";
}
async function submitRequest(payload, endpoint, fetcher = fetch) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetcher(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      signal: controller.signal,
      credentials: "omit",
    });
    const data = await response.json().catch(() => ({}));
    if (response.ok && data.accepted === true)
      return {
        accepted: true,
        message:
          "Your request has been received. No payment has been taken. We'll contact you when pricing and availability are confirmed.",
      };
    const messages = {
      400: "Please check your fields and acknowledge the prototype terms.",
      403: "This preview is not allowed to submit requests. Please use Request by email.",
      409: "We cannot yet confirm this request reference. Please contact ARI before sending another request.",
      429: "Too many requests. Please wait an hour before trying again.",
      503: "Email requests are not available on this preview yet. Your request has not been sent. You can use Request by email below.",
    };
    return {
      accepted: false,
      message:
        messages[response.status] ||
        "We could not confirm delivery to the mail server. Please retry later, or use Request by email.",
    };
  } finally {
    clearTimeout(timeout);
  }
}
module.exports = { validateRequest, submitRequest };
